exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userInfoContainer {\r\n  position: absolute;\r\n  text-align: center;\r\n  margin-top: 5px;\r\n  background-color: #EAEAE8;\r\n  color: black;\r\n  border: 1px solid;\r\n  border-color: lightgrey;\r\n  margin-left: 10px;\r\n}\r\n\r\n.userInfo {\r\n  margin: 10px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.profile-row {\r\n  padding-top: 4px;\r\n  padding-bottom: 4px;\r\n  background: #EAEAE8;\r\n  border-bottom: 1px solid;\r\n  border-bottom-color: lightgrey;\r\n}\r\n\r\n.profile-row:last-of-type {\r\n  border-bottom: none;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.logout-button {\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.notif-badge {\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  -ms-flex-pack: center;\r\n      justify-content: center;\r\n\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 6px;\r\n\r\n  background: #e53935;\r\n  /* rojo */\r\n  color: #fff;\r\n  border-radius: 999px;\r\n\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n\r\n  margin-left: 8px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/current-user/current-user.component.css
// module id = ../../../../../src/app/core/current-user/current-user.component.css
// module chunks = 16